import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { API_CONFIG, getAuthHeadersWithoutCredentials } from '../constants/api';

type CreditsContextValue = {
    credits: number | null;
    refreshCredits: () => Promise<void>;
};

const CreditsContext = createContext<CreditsContextValue | undefined>(undefined);

export const CreditsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [credits, setCredits] = useState<number | null>(null);

    const refreshCredits = useCallback(async () => {
        try {
            const response = await fetch(`${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.CREDITS}`, {
                method: 'GET',
                headers: getAuthHeadersWithoutCredentials(),
            });

            if (!response.ok) {
                throw new Error('Failed to fetch credits');
            }

            const data = await response.json();
            const newCredits = typeof data === 'number' ? data : (data?.credits as number);
            if (typeof newCredits === 'number' && !Number.isNaN(newCredits)) {
                setCredits(newCredits);
            }
        } catch (_) {
        }
    }, []);

    useEffect(() => {
        refreshCredits();
    }, [refreshCredits]);

    return (
        <CreditsContext.Provider value={ { credits, refreshCredits } }>
            { children }
        </CreditsContext.Provider>
    );
};

export const useCredits = (): CreditsContextValue => {
    const ctx = useContext(CreditsContext);
    if (!ctx) throw new Error('useCredits must be used within CreditsProvider');
    return ctx;
};


